import { http_client } from "@/plugins/http_client";

const url = '/api/v1/bolsa-no-contratados'

const getBolsaNoContratados = async (params = {}) => await http_client(`${url}`, params, 'get')

const getPlazasNoContratados = async () => await http_client(`${url}/plazas`)

const getDetalleGeneral = async (id_oferta) =>
  await http_client(`${url}/${id_oferta}/detalle-general`);

const getPersonasSeleccionadas = async (id_oferta) =>
  await http_client(`${url}/${id_oferta}/personas-seleccionadas`);

const getPersonasRemovidas = async (id_oferta) =>
  await http_client(`${url}/${id_oferta}/personas-removidas`);

const getBitacora = async (id_oferta) =>
  await http_client(`${url}/${id_oferta}/bitacora`);

const guardar = async (formData) =>
  await http_client(url, formData, "post", { "Content-Type": "multipart/form-data" });

const getDocumentosOferta = async (id_oferta) =>
  await http_client(`${url}/documentos-oferta/${id_oferta}`);

const getDocumentoBase64 = async (id_documento) =>
  await http_client(`${url}/documento-oferta/${id_documento}`);

const getDocumentosGestionCambio = async (id_oferta_gestion_cambio) =>
  await http_client(`${url}/documentos/${id_oferta_gestion_cambio}`);

const getDetalleSolicitud = async (id_solicitud) =>
  await http_client(`${url}/detalle-solicitud/${id_solicitud}`);

export default {
  getBolsaNoContratados,
  getPlazasNoContratados,
  getDetalleGeneral,
  getPersonasSeleccionadas,
  getPersonasRemovidas,
  getBitacora,
  guardar,
  getDocumentosOferta,
  getDocumentoBase64,
  getDocumentosGestionCambio,
  getDetalleSolicitud,
};
